import { FIXED_INDENTS } from 'vars/index'

export const PopupDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type PopupDirection =
  (typeof PopupDirection)[keyof typeof PopupDirection]

export const PopupAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Stretch: 'stretch',
} as const
export type PopupAlignItems =
  (typeof PopupAlignItems)[keyof typeof PopupAlignItems]

export const PopupRowGap = {
  INDENT_0: FIXED_INDENTS.INDENT_0,
  INDENT_20: FIXED_INDENTS.INDENT_20,
  INDENT_40: FIXED_INDENTS.INDENT_40,
  INDENT_60: FIXED_INDENTS.INDENT_60,
  INDENT_80: FIXED_INDENTS.INDENT_80,
  INDENT_100: FIXED_INDENTS.INDENT_100,
  INDENT_120: FIXED_INDENTS.INDENT_120,
  INDENT_140: FIXED_INDENTS.INDENT_140,
  INDENT_160: FIXED_INDENTS.INDENT_160,
} as const
export type PopupRowGap = (typeof PopupRowGap)[keyof typeof PopupRowGap]

export const PopupColumnGap = {
  INDENT_0: FIXED_INDENTS.INDENT_0,
  INDENT_20: FIXED_INDENTS.INDENT_20,
  INDENT_40: FIXED_INDENTS.INDENT_40,
  INDENT_60: FIXED_INDENTS.INDENT_60,
  INDENT_80: FIXED_INDENTS.INDENT_80,
  INDENT_100: FIXED_INDENTS.INDENT_100,
  INDENT_120: FIXED_INDENTS.INDENT_120,
  INDENT_140: FIXED_INDENTS.INDENT_140,
  INDENT_160: FIXED_INDENTS.INDENT_160,
} as const
export type PopupColumnGap =
  (typeof PopupColumnGap)[keyof typeof PopupColumnGap]

type PaddingKey =
  | 'SIZE_0'
  | 'SIZE_10'
  | 'SIZE_20'
  | 'SIZE_30'
  | 'SIZE_40'
  | 'SIZE_50'
  | 'SIZE_60'
export const PopupPaddings: Record<PaddingKey, readonly string[]> = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_100,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_120,
    FIXED_INDENTS.INDENT_10,
  ],
  SIZE_20: [
    FIXED_INDENTS.INDENT_180,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_20,
  ],
  SIZE_30: [FIXED_INDENTS.INDENT_140, FIXED_INDENTS.INDENT_20], //[56px, 8px]
  SIZE_40: [
    FIXED_INDENTS.INDENT_180,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
  ], //[72px, 56px, 56px]
  SIZE_50: [FIXED_INDENTS.INDENT_140, FIXED_INDENTS.INDENT_140], // [56px, 56px]
  SIZE_60: [
    FIXED_INDENTS.INDENT_80,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_140,
  ],
} as const
export type PopupPadding = (typeof PopupPaddings)[keyof typeof PopupPaddings]

export const PopupImageAspectRatio = {
  HORIZONTAL_DEFAULT: 1.69,
} as const
export type PopupImageAspectRatio =
  (typeof PopupImageAspectRatio)[keyof typeof PopupImageAspectRatio]
